import { ApiBestPricePackageModel } from '@ibe/api';

class PackageItemSelectEvent {
  item: ApiBestPricePackageModel;

  index?: number;
}

export default PackageItemSelectEvent;
